import { ButtonHTMLAttributes, ReactNode } from 'react';

interface TextureButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children?: ReactNode;
}

export const TextureButton = ({ children, className, ...props }: TextureButtonProps) => {
    return (
        <button
            {...props}
            className={`
        group relative w-full py-6 rounded-2xl overflow-hidden
        transition-all duration-200 active:scale-[0.98]
        shadow-[0_0_40px_-10px_rgba(255,215,0,0.3)] /* Gold glow underneath */
        ${className}
      `}
        >
            {/* 1. The Gradient Base */}
            <div className="absolute inset-0 bg-gradient-to-b from-[#FFD700] to-[#B8860B]" />

            {/* 2. The Noise Texture (Crucial for the 'Heavy' look) */}
            <div className="absolute inset-0 opacity-20 bg-[url('/noise.svg')] mix-blend-overlay" />

            {/* 3. The Shine Effect (Animates on hover) */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-gradient-to-r from-transparent via-white to-transparent -skew-x-12 translate-x-[-100%] group-hover:animate-shine" />

            {/* 4. The Content */}
            <div className="relative z-10 flex flex-col items-center justify-center text-black">
                {children || (
                    <>
                        <span className="text-xs font-bold tracking-[0.2em] opacity-60 uppercase mb-1">
                            Ready to Work
                        </span>
                        <span className="text-3xl font-black italic tracking-tighter drop-shadow-sm">
                            ENTER SESSION
                        </span>
                    </>
                )}
            </div>
        </button>
    );
};
